export const FirebaseConfig = {
  	apiKey: "AIzaSyD-NFnEZVpPFjG2594OdwRe7viwZHpD1Cg",
    authDomain: "gg-ridesharing.firebaseapp.com",
    databaseURL: "https://gg-ridesharing.firebaseio.com",
    projectId: "gg-ridesharing",
    storageBucket: "gg-ridesharing.appspot.com",
    messagingSenderId: "345670557182",
    appId: "1:345670557182:web:06121e440ad93b7b6534af",
    measurementId: "G-XSZ297F9N7"
};

export const google_map_key = 'AIzaSyC5aQCgr3c3t-nQihra_1dqp-lGpAhCj5U';